<template>
  <section class="offerDetailAccommodationList defaultSectionPaddings">
    <div class="container--Medium">
      <h2 v-text="data.title" />
      
      <div v-if="page.accommodations?.length" class="offerDetailAccommodationList__Offers">
        <template v-if="page.accommodations.length === 1">
          <PropertyItem :property="accommodations[0]" vertical without-border without-book-button without-price />
        </template>
        <PropertyItem v-else v-for="accommodation in accommodations" :property="accommodation" without-border without-price />
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({ data: {}});
  const { page } = usePage();
  const { accommodationsData } = useSetup();
  const accommodations = page.value.accommodations.map(item => accommodationsData.value[item]);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_offerDetailAccommodationList.scss');
</style>